import { withInstall } from '@ideaz/utils'
import WaterMark from './src/index'

export default withInstall(WaterMark)
